import { render } from "./EventProgram.vue?vue&type=template&id=a057187c&scoped=true"
import script from "./EventProgram.vue?vue&type=script&lang=js"
export * from "./EventProgram.vue?vue&type=script&lang=js"

import "./EventProgram.vue?vue&type=style&index=0&id=a057187c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a057187c"]])

export default __exports__